import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// Vendor Payable Write-off (legacy /Purchase/VendorPayableWriteoff).
// Params go through axios `params` so invoice / PO numbers with '&' or '/' are encoded.

const headers = { 'Content-Type': 'application/json' };

const handle = (error, fallback) => {
    if (error.response?.data) throw error.response.data;
    throw error.message || fallback;
};

// 1. Vendors of a type that have write-off-able POs → [{ VendorCode, VendorName }]
export const getWriteoffVendors = async ({ VendorType, RoleId, Userid }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/GetPOPaymentVendorwo`, {
            params: { VendorType, RoleId, Userid }, headers,
        });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch vendors'); }
};

// 2. Vendor's POs → [{ PONo, PONoDesc }]
export const getWriteoffPOs = async ({ VendorCode, VendorType }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/GetPOForwriteoff`, {
            params: { VendorCode, VendorType }, headers,
        });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch POs'); }
};

// 3. Open invoices of the selected POs. PONo is "PO1,PO2," — the SP's charindex loop needs the trailing comma.
export const getWriteoffInvoices = async ({ VendorCode, PONo }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/GetInvoiceDataForWOPayment`, {
            params: { VendorCode, PONo }, headers,
        });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch invoices'); }
};

// 4. Tax / deduction lines of one invoice (popup for invoices with tax)
export const getWriteoffInvoiceTaxes = async ({ InvoiceNo }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/GetInvoiceTaxDeductionwo`, {
            params: { InvoiceNo }, headers,
        });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch invoice taxes'); }
};

// 5. Save → Data "Submited$<RefNo>" on success, else the SP's message
export const saveVendorPayableWriteoff = async (payload) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/Purchase/SaveWriteoffPOInvoicePayment`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error, 'Failed to save vendor payable write-off'); }
};
